<template>
  <div>
    <woot-modal :show.sync="show" :on-close="onClose">
      <woot-modal-header :header-title="$t('PIPELINES.CREATE_BOARD')" />
      <div class="remainder-table">
        <div class="remainder-modal">
          <div class="remainder-input date-time">
            <div class="date-time-input">
              <label>
                {{ $t('PIPELINES.EDIT_NAME') }}
                <span class="text-red-500">*</span>
                <woot-input
                  class="status-name"
                  :class="{ error: $v.name.$error }"
                  :placeholder="$t('PIPELINES.ENTER_NAME_BOARD')"
                  :error="getAddMoreBoard"
                  v-model.trim="name"
                  @input="$v.name.$touch"
                />
              </label>

              <div class="mt-4">
                <label class="block font-medium mb-2">Add Pipeline For New Board:</label>
                <div class="flex flex-col gap-2">
                  <div v-for="(status, index) in statusOptions" :key="index" class="flex items-center gap-2">
                    <!-- Status name input -->
                    <input type="text" v-model="status.name"
                      class="border border-gray-300 rounded px-3 py-1 my-0 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter status name" required />

                    <!-- Delete button -->
                    <div @click="deleteStatus(index)"
                      class="text-white bg-red-600 rounded-lg hover:text-white/70 font-semibold px-2 flex items-center justify-center py-1 hover:bg-red-500 cursor-pointer transition"
                      title="Delete status">
                      ✕
                    </div>
                  </div>
                </div>

                <!-- Add new status button -->
                <div class="mt-4">
                  <div @click="addNewStatus"
                    class="cursor-pointer" title="Add New Status">
                    + New Status
                  </div>
                </div>
              </div>

              
              <!-- <div class="mt-4">
                <label class="block font-medium mb-2"
                  >Add Pipeline For New Board:</label
                >
                <div class="flex flex-col gap-2 text-sm">
                  <label>
                    <input
                      type="checkbox"
                      value="New Lead"
                      v-model="statuses"
                    />
                    New Lead
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      value="Contacted"
                      v-model="statuses"
                    />
                    Contacted
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      value="Qualified"
                      v-model="statuses"
                    />
                    Qualified
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      value="Unqualified"
                      v-model="statuses"
                    />
                    Unqualified
                  </label>
                </div>

     

              </div> -->
              <div class="flex justify-end items-center pb-6 pt-2 gap-2 w-full">
                <woot-submit-button
                  :disabled="
                    $v.name.$invalid ||
                    uiFlags.isCreateBoard ||statusOptions.length===0 ||
                    statusOptions.some(status => status.name.trim() === '')
                  "
                  :loading="uiFlags.isCreateBoard"
                  :button-text="'Submit'"
                  class="button-color"
                  @click="createBoard"
                />
                <woot-button
                  class="button clear cancel-btn"
                  @click.prevent="onClose"
                >
                  {{ $t('LABEL_MGMT.FORM.CANCEL') }}
                </woot-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </woot-modal>
  </div>
</template>
  
  <script>
import alertMixin from 'shared/mixins/alertMixin';
import { mapGetters } from 'vuex';
import validations from './helpers/validations';
import pipelineMixin from './helpers/pipelineMixin.js';
import { getRandomColor } from 'dashboard/helper/labelColor';
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: '',
      statuses: [],
      statusOptions: [
      { name: 'New Lead', color: '#EFF3FF' },
      { name: 'Contacted', color: '#FFF2CC' },
      { name: 'Qualified', color: '#DAF8D3' },
      { name: 'Unqualified', color: '#FDE8E9' },
    ],
    };
  },
  validations,
  mounted() {
    this.color = getRandomColor();
  },
  computed: {
    ...mapGetters({
      uiFlags: 'pipelines/getUIFlags',
    }),
  },
  mixins: [alertMixin, pipelineMixin],
  
  methods: {
    onClose() {
      this.resetStatusOptions(); 
      this.$emit('close');
    },
    resetStatusOptions() {
      this.statusOptions = [
        { name: 'New Lead', color: '#EFF3FF' },
        { name: 'Contacted', color: '#FFF2CC' },
        { name: 'Qualified', color: '#DAF8D3' },
        { name: 'Unqualified', color: '#FDE8E9' },
      ];
    },
    async createBoard() {
      const payload = {
          name: this.name,
          // statuses_attributes: this.statuses.map(statusName => {
          //   const matched = this.statusOptions.find(
          //     option => option.name === statusName
          //   );
            statuses_attributes: this.statusOptions
            .filter(status => status.name.trim() !== '') 
            .map(status => ({
              name: status.name,
              color: status.color || '#CCCCCC',
            })),
          //   return {
          //     name: statusName,
          //     color: matched ? matched.color : '#CCCCCC',
          //   };
          // }),
      };
      console.log("My Status Object",payload);
      const response = await this.$store.dispatch(
        'pipelines/AddBoard',
        payload
      );
      this.onClose();
      this.showAlert(response.data.message, { success: response.data.success });
      this.resetdata();
      this.getBoards();
    },
    getBoards() {
      this.$store.dispatch('pipelines/getBoards');
    },
    resetdata() {
      (this.name = ''), (this.description = '');
      this.statuses = [];
      this.resetStatusOptions();
    },
    deleteStatus(index) {
    this.statusOptions.splice(index, 1);  // Removes the status from the array
    },
    // Method to add a new status with a default color and empty name
    addNewStatus() {
      this.statusOptions.push({ name: '', color: '#DAF8D3' });  // Default color can be modified
    }
  },
};
</script>
  
  <style lang="scss" scoped>
.remainder-table {
  margin: 10px 35px;
}

.remainder-modal {
  display: flex;
}

.remainder-input {
  width: 100%;
}
.remainder-text {
  width: 20%;
  font-size: 14px;
  font-weight: 500;
}
.remainder-text-select {
  padding: 5% 0px;
}
.input-textarea textarea {
  resize: none;
}
.date-time {
  display: flex;
  justify-content: space-between;
}
.date,
.time {
  margin: 0px 2%;
}
.remainder-time {
  display: flex;
  justify-content: inherit;
  width: 35%;
}
.date-time-input {
  width: 100%;
}
.footer {
  @apply mt-6 flex justify-end;
}
.remainder-time select {
  width: 66%;
}
.remainder-footer {
  flex-direction: inherit;
}
.labels-dropdown {
  display: flex;
  width: 45%;
  justify-content: space-evenly;
}
.automation-dropdown {
  display: flex;
  width: 45%;
  justify-content: space-evenly;
}
.label-automation {
  padding-top: 10px;
  justify-content: space-between;
}
.labels-text {
  width: 30%;
}
.label-input {
  width: 50%;
}
.automation-text {
  width: 55%;
}
.automation-input {
  width: 50%;
}
.overlay {
  position: fixed;
  margin: auto;
  left: 50vw;
  width: 250px;
}
.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  cursor: pointer;
  font-size: 20px;
}
.date-time-picker-modal {
  width: 90%;
  padding-top: 2%;
}
.cancel-btn {
  background-color: #fff;
  color: #40518a;
}
.cancel-btn:hover {
  background-color: #f9f9f9;
  color: #40518a;
}
.button-color {
  background-color: #40518a;
}
</style>
      